
export const pageRoutes = {
    AboutMe: '/about-me',
    GameHome: '/ai/game-home',
    SpellingBee: '/ai/spelling-bee',
    LetterBoxed: '/ai/letter-boxed',
    Anagrams: '/ai/anagrams',
    WordHunt: '/ai/word-hunt',
    WordBites: '/ai/word-bites',
    Connect4: '/ai/connect4',
    Gomoku: '/ai/gomoku',
    Othello: '/ai/othello',
    SeaBattle: '/ai/sea-battle',
    Mancala: '/ai/mancala',
    Checkers: '/ai/checkers',
};

export const externalRoutes = {
    GitHub: "https://github.com/k-gerner",
    LinkedIn: "https://linkedin.com/in/kyle-gerner/",
    Email: "mailto:kgerner@vt.edu,kgcoltsfan@gmail.com",
    PhiBetaKappa: 'https://www.pbk.org/',
    Yext: 'https://www.yext.com/',
    NewsweekTJRanking: 'https://www.newsweek.com/2014/09/19/number-1-high-school-america-offers-real-head-start-268693.html',
};
